
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AvatarSelector } from "./AvatarSelector";
import { KnittingPreferences } from "./KnittingPreferences";
import { CommunicationPreferences } from "@/components/account/CommunicationPreferences";

interface ProfileFormProps {
  displayName: string;
  setDisplayName: (name: string) => void;
  bio: string;
  setBio: (bio: string) => void;
  knittingStyle: "continental" | "english" | "not-specified";
  setKnittingStyle: (style: "continental" | "english" | "not-specified") => void;
  measurementSystem: "metric" | "imperial";
  setMeasurementSystem: (system: "metric" | "imperial") => void;
  customAvatar: string | null;
  setCustomAvatar: (url: string | null) => void;
  communicationPrefs: {
    email_marketing: boolean;
    email_project_updates: boolean;
    email_community_updates: boolean;
  };
  handlePreferenceChange: (key: string, checked: boolean) => void;
}

export const ProfileForm = ({
  displayName,
  setDisplayName,
  bio,
  setBio,
  knittingStyle,
  setKnittingStyle,
  measurementSystem,
  setMeasurementSystem,
  customAvatar,
  setCustomAvatar,
  communicationPrefs,
  handlePreferenceChange
}: ProfileFormProps) => {
  return (
    <div className="py-4 space-y-6">
      <div className="grid gap-4">
        <div className="space-y-2">
          <Label>Profile picture</Label>
          <AvatarSelector 
            customAvatar={customAvatar}
            setCustomAvatar={setCustomAvatar}
            displayName={displayName}
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="displayName">Display name</Label>
          <Input 
            id="displayName" 
            value={displayName} 
            onChange={(e) => setDisplayName(e.target.value)} 
            placeholder="Enter your display name"
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="bio">Bio</Label>
          <Input 
            id="bio" 
            value={bio} 
            onChange={(e) => setBio(e.target.value)} 
            placeholder="Tell us a bit about yourself"
          />
        </div>
        
        <KnittingPreferences
          knittingStyle={knittingStyle}
          setKnittingStyle={setKnittingStyle}
          measurementSystem={measurementSystem}
          setMeasurementSystem={setMeasurementSystem}
        />
        
        <div className="space-y-2">
          <Label>Communication Preferences</Label>
          <CommunicationPreferences
            emailMarketing={communicationPrefs.email_marketing}
            emailProjectUpdates={communicationPrefs.email_project_updates}
            emailCommunityUpdates={communicationPrefs.email_community_updates}
            onPreferenceChange={handlePreferenceChange}
          />
        </div>
      </div>
    </div>
  );
};
